import * as React from "react";

import "./expand1-table.scss";

import {MasterTable} from "../master-table/master-table";

export const Expand1Table = (
    {
        list,
        columns,
        sortState = undefined,
        noDataMessage=undefined,
        noDataProps=undefined,
    }
) => MasterTable({
    className: "expand1-table-9df",
    sortState,
    noDataMessage,
    noDataProps,
    list: list?.map((row) => ({
        ...row,
        columns: [
            {
                renderCell: ({expanded, index: i}) => (
                    <i
                        className={expanded ? "fa fa-chevron-up" : "fa fa-chevron-down"}
                        xd-qa-type={row.expanderXdQaType ?? "icon"}
                        xd-qa-name={row.expanderXdQaName ?? "expander " + (row.rowId ?? i) }
                    />
                ),
                xdQaName: false,
                xdQaType: false,
                className: "expander",
                onClick: ({expanded, setExpanded}) => setExpanded(!expanded),
            },
            ...row.columns,
        ],
        renderExpansion: () => (
            <div className="box">
                {row.renderExpansion()}
            </div>
        ),
    })),
    columns: [
        {
            className: "expander",
            xdQaType: "style_filter",
            xdQaName: "master expander",
            align: "center",
            render: ({expanded}) => (
                <i
                    className={expanded ? "fa fa-minus" : "fa fa-plus"}
                    xd-qa-type="icon"
                    xd-qa-name="master expander"
                />
            ),
            onClick: ({expanded, collapseAll, expandAll}) => expanded ? collapseAll() : expandAll(),
        },
        ...columns
            .map((column) => ({
                ...column,
                xdQaType: "style_filter",
                xdQaName: column.label+" sort",
            }))
        ,
    ],
});
